import { PayloadAction } from 'typesafe-actions';
import { CardActionState, CardActionContextActionTypes } from './types';

const CardActionsReducer = (
  state: CardActionState,
  action: PayloadAction<CardActionContextActionTypes, any>,
): CardActionState => {
  switch (action.type) {
    default:
      return state;
  }
};

export { CardActionsReducer };
